export default __webpack_public_path__ + "static/media/slider_6-lg@1x.06652dea.jpg";